//
// Expandable items
//
// This is just a polyfill for browsers that don't support the details element
// ---------------------------------------------------------------------------

'use strict';

import '../vendor/jquery.details.js';

$('details').details();


// Custom expandable item. Can attach this to any html node and it'll toggle
// u-hide on any node defined by the attribute data-body-id
$('.js-expandable-item-handle').on('click', function() {
    const body = $('#' + $(this).data('bodyId'));

    body.toggleClass('u-hide');
});

// Custom expandable item. Can attach this to any html node and it'll toggle
// u-hide on any node defined by the attribute data-body-id
$('.js-checkable-item-handle').on('change', 'input', function() {
    const body = $('#' + $(this).closest('.js-checkable-item-handle').data('bodyId'));

    body.toggleClass('u-hide');
});

// on load
$('.js-checkable-item-handle').each(function() {
    const handle = $(this);

    if (handle.find('input').is(':checked')) {
        const body = $('#' + handle.closest('.js-checkable-item-handle').data('bodyId'));

        body.removeClass('u-hide');
    }
});



// WEBPACK FOOTER //
// ./src/js/components/expandable-item.js